/* DV_ADS_ATTRIBUTION_BRIDGE_20260804
 * Marketing consent varsa reklam tiklamasini sifreli sunucu kaydina cevirir.
 * Shopify sepetine yalniz anlamsiz dvattr_* referansi yazilir; click ID yazilmaz.
 */
(function(window, document) {
  'use strict';

  if (window.__DV_ADS_ATTRIBUTION_BRIDGE_20260804__) return;
  window.__DV_ADS_ATTRIBUTION_BRIDGE_20260804__ = true;

  var ENDPOINT = 'https://dolcevita-massimo.ngrok.io/api/massimo/dv-attribution-capture';
  var REVOKE_ENDPOINT = 'https://dolcevita-massimo.ngrok.io/api/massimo/dv-attribution-revoke';
  var STORAGE_KEY = 'dvAdsAttributionRefV1';
  var REF_RE = /^dvattr_[A-Za-z0-9_-]{30,80}$/;
  var CART_SYNC_TIMEOUT_MS = 1500;
  var PURCHASE_WAIT_MS = 1800;
  var activeRef = '';
  var capturePromise = null;
  var cartSyncPromise = Promise.resolve(false);
  var lastCartSyncRef = null;
  var cartSyncGeneration = 0;
  var cartAbortController = null;
  var cartRequestGenerationInFlight = 0;
  var cartFenceScheduled = Object.create(null);
  var desiredCartRef = '';
  var desiredCartState = 'cleared';
  var cartInspectionPromise = null;
  var consentGeneration = 0;
  var lastCapturedClickKey = '';
  var privacyClearPromise = null;

  function marketingAllowed() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      /* The live store has no consent-tracking API. Preserve the verified live
         policy: obey the API when Shopify exposes it; otherwise allow capture. */
      if (!cp || typeof cp.marketingAllowed !== 'function') return true;
      return Boolean(cp.marketingAllowed());
    } catch (_) {
      return true;
    }
  }

  // DV_ATTRIBUTION_CART_ATTRIBUTE_20260817
  function cartUpdateUrl() {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    root = typeof root === 'string' && root.charAt(0) === '/' ? root : '/';
    return root + 'cart/update.js';
  }

  function cartJsonUrl() {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    root = typeof root === 'string' && root.charAt(0) === '/' ? root : '/';
    return root + 'cart.js';
  }

  function waitMs(ms) {
    return new Promise(function(resolve) { window.setTimeout(resolve, ms); });
  }

  function scheduleLatestCartFence(staleGeneration, delayMs) {
    if (staleGeneration >= cartSyncGeneration) return;
    var key = String(staleGeneration) + ':' + String(delayMs || 0);
    if (cartFenceScheduled[key]) return;
    cartFenceScheduled[key] = true;
    window.setTimeout(function() {
      delete cartFenceScheduled[key];
      if (staleGeneration >= cartSyncGeneration) return;
      lastCartSyncRef = null;
      syncCartAttribute(desiredCartRef, true, desiredCartState);
    }, Math.max(0, Number(delayMs || 0)));
  }

  function cartAttributeRequest(ref, attributionState, generation) {
    return new Promise(function(resolve) {
      var settled = false;
      var controller = typeof window.AbortController === 'function'
        ? new window.AbortController()
        : null;
      if (cartAbortController && typeof cartAbortController.abort === 'function') {
        try { cartAbortController.abort(); } catch (_) {}
      }
      cartAbortController = controller;
      cartRequestGenerationInFlight = generation;
      var finish = function(value) {
        if (settled) return;
        settled = true;
        if (cartRequestGenerationInFlight === generation) {
          cartRequestGenerationInFlight = 0;
        }
        if (timer && typeof window.clearTimeout === 'function') window.clearTimeout(timer);
        resolve(Boolean(value));
      };
      var timer = window.setTimeout(function() {
        if (controller) {
          try { controller.abort(); } catch (_) {}
        }
        finish(false);
      }, CART_SYNC_TIMEOUT_MS);
      var requestOptions = {
        method: 'POST',
        credentials: 'same-origin',
        keepalive: true,
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          attributes: {
            _dvAttributionRef: ref,
            _dvAttributionState: attributionState
          }
        })
      };
      if (controller) requestOptions.signal = controller.signal;
      fetch(cartUpdateUrl(), requestOptions).then(function(response) {
        if (!response.ok) throw new Error('attribution_cart_sync_failed');
        return response.json();
      }).then(function(cart) {
        if (generation !== cartSyncGeneration) {
          scheduleLatestCartFence(generation, 10);
          return finish(false);
        }
        var readback = cart && cart.attributes && cart.attributes._dvAttributionRef;
        var stateReadback = cart && cart.attributes && cart.attributes._dvAttributionState;
        if (
          String(readback || '') !== ref ||
          String(stateReadback || '') !== attributionState
        ) {
          throw new Error('attribution_cart_readback_mismatch');
        }
        finish(true);
      }).catch(function() {
        if (generation !== cartSyncGeneration) {
          scheduleLatestCartFence(generation, 100);
        }
        finish(false);
      });
    });
  }

  function syncCartAttribute(refValue, forceClear, stateValue) {
    var ref = REF_RE.test(String(refValue || '')) ? String(refValue) : '';
    var attributionState = String(stateValue || (ref ? 'active' : 'cleared'));
    var syncKey = ref + '|' + attributionState;
    if (!ref && !forceClear) return Promise.resolve(false);
    if (lastCartSyncRef === syncKey && !forceClear) return cartSyncPromise;
    lastCartSyncRef = syncKey;
    desiredCartRef = ref;
    desiredCartState = attributionState;
    cartSyncGeneration += 1;
    var generation = cartSyncGeneration;
    var supersededGeneration = cartRequestGenerationInFlight;
    if (supersededGeneration && cartAbortController && typeof cartAbortController.abort === 'function') {
      try { cartAbortController.abort(); } catch (_) {}
      scheduleLatestCartFence(supersededGeneration, CART_SYNC_TIMEOUT_MS + 50);
    }
    var attempt = function() {
      return cartAttributeRequest(ref, attributionState, generation);
    };
    cartSyncPromise = attempt().then(function(firstOk) {
      if (generation !== cartSyncGeneration) return false;
      if (firstOk) return true;
      return waitMs(75).then(function() {
        if (generation !== cartSyncGeneration) return false;
        return attempt();
      });
    });
    cartSyncPromise = cartSyncPromise.then(function(ok) {
      if (!ok && lastCartSyncRef === syncKey) lastCartSyncRef = null;
      return ok;
    }).catch(function() {
      if (lastCartSyncRef === syncKey) lastCartSyncRef = null;
      return false;
    });
    return cartSyncPromise;
  }

  function inspectCartAndClearIfStale() {
    if (cartInspectionPromise) return cartInspectionPromise;
    cartInspectionPromise = fetch(cartJsonUrl(), {
      method: 'GET',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    }).then(function(response) {
      if (!response.ok) throw new Error('attribution_cart_inspection_failed');
      return response.json();
    }).then(function(cart) {
      var attributes = cart && cart.attributes || {};
      var ref = String(attributes._dvAttributionRef || '');
      var state = String(attributes._dvAttributionState || '').toLowerCase();
      var storedNow = loadStoredRef();
      if (storedNow) {
        activeRef = storedNow;
        injectIntoForms();
        return syncCartAttribute(activeRef, false, 'active');
      }
      if (!ref && state !== 'active') return true;
      return syncCartAttribute('', true, 'cleared');
    }).catch(function() { return false; });
    return cartInspectionPromise;
  }

  function revokeRef(refValue) {
    var ref = REF_RE.test(String(refValue || '')) ? String(refValue) : '';
    if (!ref) return Promise.resolve(false);
    return fetch(REVOKE_ENDPOINT, {
      method: 'POST',
      mode: 'cors',
      credentials: 'omit',
      keepalive: true,
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ ref: ref })
    }).then(function(response) { return response.ok; }).catch(function() { return false; });
  }

  function loadStoredRef() {
    try {
      var parsed = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || 'null');
      if (!parsed || !REF_RE.test(String(parsed.ref || '')) || Number(parsed.expiresAt || 0) <= Date.now()) {
        window.localStorage.removeItem(STORAGE_KEY);
        return '';
      }
      return String(parsed.ref);
    } catch (_) {
      return '';
    }
  }

  function storeRef(ref, expiresAt, expectedConsentGeneration) {
    if (
      expectedConsentGeneration !== consentGeneration ||
      !marketingAllowed() ||
      !REF_RE.test(String(ref || ''))
    ) return false;
    activeRef = String(ref);
    privacyClearPromise = null;
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify({
        ref: activeRef,
        expiresAt: Number(expiresAt || 0)
      }));
    } catch (_) {}
    injectIntoForms();
    return true;
  }

  function clearRef(reason) {
    var refToRevoke = activeRef;
    var attributionState = String(reason || 'cleared');
    var revokeServer = attributionState === 'revoked';
    consentGeneration += 1;
    lastCapturedClickKey = '';
    activeRef = '';
    try { window.localStorage.removeItem(STORAGE_KEY); } catch (_) {}
    document.querySelectorAll('input[data-dv-attribution-ref]').forEach(function(input) {
      input.remove();
    });
    var revokePromise = revokeServer ? revokeRef(refToRevoke) : Promise.resolve(false);
    lastCartSyncRef = null;
    var clearPromise = syncCartAttribute('', true, attributionState);
    if (revokeServer) {
      privacyClearPromise = Promise.all([revokePromise, clearPromise]).then(function() {
        return true;
      });
      return privacyClearPromise;
    }
    return clearPromise;
  }

  function currentClickState() {
    var params;
    try { params = new URL(window.location.href).searchParams; }
    catch (_) { return { present: false, valid: false, click: null }; }
    var found = [];
    ['gclid', 'gbraid', 'wbraid'].forEach(function(type) {
      var value = String(params.get(type) || '').trim();
      if (value) found.push({ clickType: type, clickId: value });
    });
    return {
      present: found.length > 0,
      valid: found.length === 1 && /^[A-Za-z0-9._~-]{10,300}$/.test(found[0].clickId),
      click: found.length === 1 ? found[0] : null
    };
  }

  function capture() {
    if (!marketingAllowed()) {
      return clearRef('revoked').then(function() { return null; });
    }
    var clickState = currentClickState();
    if (clickState.present && !clickState.valid) {
      return clearRef('invalid_click').then(function() { return null; });
    }
    var click = clickState.click;
    if (!clickState.present) {
      activeRef = loadStoredRef();
      injectIntoForms();
      if (activeRef) {
        return syncCartAttribute(activeRef, false, 'active').then(function() {
          return activeRef;
        });
      }
      return inspectCartAndClearIfStale().then(function() { return null; });
    }
    if (capturePromise) return capturePromise;
    var clickKey = click.clickType + ':' + click.clickId;
    if (activeRef && lastCapturedClickKey === clickKey) {
      return syncCartAttribute(activeRef).then(function() { return activeRef; });
    }
    // A stale cart can outlive localStorage. Every new click therefore fences
    // the cart, even when this document has no in-memory ref.
    var supersedePromise = clearRef('superseded');
    var requestConsentGeneration = consentGeneration;
    capturePromise = fetch(ENDPOINT, {
      method: 'POST',
      mode: 'cors',
      credentials: 'omit',
      keepalive: true,
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        clickType: click.clickType,
        clickId: click.clickId,
        landingPath: window.location.pathname || '/',
        consent: true
      })
    }).then(function(response) {
      if (!response.ok) throw new Error('attribution_capture_failed');
      return response.json();
    }).then(function(data) {
      if (!storeRef(data.ref, data.expiresAt, requestConsentGeneration)) {
        return Promise.all([revokeRef(data.ref), supersedePromise]).then(function() {
          return null;
        });
      }
      lastCapturedClickKey = clickKey;
      return syncCartAttribute(activeRef, false, 'active').then(function() { return activeRef; });
    }).catch(function() {
      return supersedePromise.then(function() { return null; });
    }).finally(function() {
      capturePromise = null;
    });
    return capturePromise;
  }

  function attributionReadyForPurchase() {
    var clickState = currentClickState();
    var work;
    if (!marketingAllowed()) {
      work = privacyClearPromise || clearRef('revoked');
    } else if (capturePromise) {
      work = capturePromise;
    } else if (clickState.present) {
      work = capture();
    } else if (activeRef) {
      work = syncCartAttribute(activeRef);
    } else if (cartInspectionPromise) {
      work = cartInspectionPromise;
    } else {
      return Promise.resolve('');
    }
    work = Promise.resolve(work).catch(function() { return null; });
    return Promise.race([
      work,
      waitMs(PURCHASE_WAIT_MS).then(function() { return null; })
    ]).then(function() { return marketingAllowed() ? activeRef : ''; });
  }

  function attachRefToJson(body, ref) {
    if (!body || typeof body !== 'object') return body;
    if (Array.isArray(body.items)) {
      body.items.forEach(function(item) {
        if (!item || typeof item !== 'object') return;
        item.properties = item.properties && typeof item.properties === 'object'
          ? item.properties
          : {};
        item.properties._dvAttributionRef = ref;
      });
    } else {
      body.properties = body.properties && typeof body.properties === 'object'
        ? body.properties
        : {};
      body.properties._dvAttributionRef = ref;
    }
    return body;
  }

  function injectRefIntoCartAddOptions(options) {
    var ref = marketingAllowed() && REF_RE.test(activeRef) ? activeRef : '';
    if (!ref || !options || !options.body) return options;
    var body = options.body;
    try {
      if (typeof window.FormData === 'function' && body instanceof window.FormData) {
        body.set('properties[_dvAttributionRef]', ref);
      } else if (
        typeof window.URLSearchParams === 'function' &&
        body instanceof window.URLSearchParams
      ) {
        body.set('properties[_dvAttributionRef]', ref);
      } else if (typeof body === 'string') {
        try {
          options.body = JSON.stringify(attachRefToJson(JSON.parse(body), ref));
        } catch (_) {
          var params = new URLSearchParams(body);
          params.set('properties[_dvAttributionRef]', ref);
          options.body = params.toString();
        }
      }
    } catch (_) {}
    return options;
  }

  function isCartAddRequest(input) {
    var url = typeof input === 'string'
      ? input
      : (input && typeof input.url === 'string' ? input.url : '');
    try {
      var pageUrl = new URL(window.location.href);
      var requestUrl = new URL(url, pageUrl.origin);
      return requestUrl.origin === pageUrl.origin &&
        /(?:^|\/)cart\/add(?:\.js)?\/?$/.test(requestUrl.pathname);
    } catch (_) {
      return false;
    }
  }

  function injectRefIntoCartAddRequest(input, options) {
    var ref = marketingAllowed() && REF_RE.test(activeRef) ? activeRef : '';
    if (!ref) return Promise.resolve([input, options]);
    if (options && options.body) {
      return Promise.resolve([input, injectRefIntoCartAddOptions(options)]);
    }
    if (
      typeof window.Request !== 'function' ||
      !(input instanceof window.Request) ||
      typeof input.clone !== 'function'
    ) return Promise.resolve([input, options]);
    var clone = input.clone();
    var contentType = String(clone.headers && clone.headers.get('content-type') || '').toLowerCase();
    var bodyPromise;
    if (contentType.indexOf('multipart/form-data') !== -1 && typeof clone.formData === 'function') {
      bodyPromise = clone.formData().then(function(body) {
        body.set('properties[_dvAttributionRef]', ref);
        return { body: body, dropContentType: true };
      });
    } else if (contentType.indexOf('application/json') !== -1) {
      bodyPromise = clone.json().then(function(body) {
        return { body: JSON.stringify(attachRefToJson(body, ref)), dropContentType: false };
      });
    } else {
      bodyPromise = clone.text().then(function(text) {
        var params = new URLSearchParams(text);
        params.set('properties[_dvAttributionRef]', ref);
        return { body: params.toString(), dropContentType: false };
      });
    }
    return bodyPromise.then(function(prepared) {
      var headers = new window.Headers(input.headers);
      if (prepared.dropContentType) headers.delete('content-type');
      return [new window.Request(input, { body: prepared.body, headers: headers }), options];
    }).catch(function() { return [input, options]; });
  }

  function installCartAddFetchGate() {
    if (window.__DV_ATTRIBUTION_CART_ADD_FETCH_GATE_20260817__) return;
    if (typeof window.fetch !== 'function') return;
    window.__DV_ATTRIBUTION_CART_ADD_FETCH_GATE_20260817__ = true;
    var originalFetch = window.fetch;
    window.fetch = function(input, options) {
      if (!isCartAddRequest(input)) return originalFetch.apply(this, arguments);
      var self = this;
      var args = Array.prototype.slice.call(arguments);
      return attributionReadyForPurchase().then(function() {
        return injectRefIntoCartAddRequest(args[0], args[1]).then(function(prepared) {
          args[0] = prepared[0];
          args[1] = prepared[1];
          return originalFetch.apply(self, args);
        });
      });
    };
  }

  function isPurchaseForm(form, submitter) {
    if (!form || form.nodeType !== 1) return false;
    var action = String(form.getAttribute('action') || '');
    var pageUrl;
    var actionUrl;
    try {
      pageUrl = new URL(window.location.href);
      actionUrl = new URL(action || pageUrl.href, pageUrl.origin);
    } catch (_) {
      return false;
    }
    if (actionUrl.origin !== pageUrl.origin) return false;
    if (/(?:^|\/)cart\/add(?:\.js)?\/?$/.test(actionUrl.pathname)) return true;
    var submitterName = String(submitter && submitter.name || '').toLowerCase();
    return /(?:^|\/)cart\/?$/.test(actionUrl.pathname) && submitterName === 'checkout';
  }

  function gatePurchaseSubmit(event) {
    var form = event.target;
    if (!isPurchaseForm(form, event.submitter)) return;
    if (form.getAttribute('data-dv-attribution-replay') === '1') {
      form.removeAttribute('data-dv-attribution-replay');
      injectIntoForm(form);
      return;
    }
    if (
      marketingAllowed() &&
      !capturePromise &&
      !activeRef &&
      !cartInspectionPromise &&
      !currentClickState().present
    ) return;
    event.preventDefault();
    if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
    else if (typeof event.stopPropagation === 'function') event.stopPropagation();
    var submitter = event.submitter || null;
    attributionReadyForPurchase().then(function() {
      injectIntoForm(form);
      form.setAttribute('data-dv-attribution-replay', '1');
      if (typeof form.requestSubmit === 'function') form.requestSubmit(submitter || undefined);
      else if (typeof form.submit === 'function') form.submit();
    });
  }

  function injectIntoForm(form) {
    if (!activeRef || !marketingAllowed() || !form || form.nodeType !== 1) return;
    var action = String(form.getAttribute('action') || '');
    if (action.indexOf('/cart/add') === -1 && !form.querySelector('[name="id"]')) return;
    var input = form.querySelector('input[data-dv-attribution-ref]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'properties[_dvAttributionRef]';
      input.setAttribute('data-dv-attribution-ref', '1');
      form.appendChild(input);
    }
    input.value = activeRef;
  }

  function injectIntoForms() {
    if (!activeRef) return;
    document.querySelectorAll('form[action*="/cart/add"], form[data-type="add-to-cart-form"]').forEach(injectIntoForm);
  }

  activeRef = loadStoredRef();
  installCartAddFetchGate();
  window.DVAdsAttribution = Object.freeze({
    getRef: function() { return marketingAllowed() ? activeRef : ''; },
    hasClick: function() { return currentClickState().present; },
    ready: capture,
    inject: injectIntoForms,
    syncCart: function() { return syncCartAttribute(activeRef); }
  });

  document.addEventListener('DOMContentLoaded', function() {
    capture();
    injectIntoForms();
    if (window.MutationObserver) {
      new MutationObserver(injectIntoForms).observe(document.documentElement, {
        childList: true,
        subtree: true
      });
    }
  });
  document.addEventListener('visitorConsentCollected', function() {
    if (!marketingAllowed()) {
      clearRef('revoked');
      return;
    }
    capture().then(function(ref) {
      if (!ref && marketingAllowed() && !capturePromise) capture();
    });
  });
  if (typeof window.addEventListener === 'function') {
    window.addEventListener('storage', function(event) {
      if (!event || event.key !== STORAGE_KEY) return;
      consentGeneration += 1;
      lastCapturedClickKey = '';
      var stored = loadStoredRef();
      if (stored && marketingAllowed()) {
        activeRef = stored;
        injectIntoForms();
        syncCartAttribute(activeRef, false, 'active');
        return;
      }
      if (stored) {
        activeRef = stored;
        clearRef('revoked');
        return;
      }
      activeRef = '';
      document.querySelectorAll('input[data-dv-attribution-ref]').forEach(function(input) {
        input.remove();
      });
      syncCartAttribute('', true, 'cleared');
    });
  }
  document.addEventListener('submit', gatePurchaseSubmit, true);
})(window, document);
